import React, { useState, useRef } from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate, RefreshIcon, RefreshIconContainer, OptionsButton, FilterWrapper } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import refresh_act from '../../../assets/refresh-active.svg'
import { Filter as FilterIcon } from 'lucide-react'
import { usePersistedFilters } from '../../../hooks/usePersistedFilters'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { Header, Filter } from '../../../components/SubHeaderFilter/types'

export const serviceHeaders: Header[] = [
  { key: 'name', label: 'Serviço', type: 'string' },
  { key: 'area', label: 'Área', type: 'string' },
  { key: 'sector', label: 'Setor', type: 'string' },
  { key: 'category', label: 'Categoria', type: 'string' },
  { key: 'type', label: 'Tipo', type: 'string' },
  { key: 'code', label: 'Código', type: 'string' },
  { key: 'deadlineInDays', label: 'Prazo', type: 'number' },
  { key: 'executionTime', label: 'Tempo execução', type: 'number' },
  { key: 'setupTime', label: 'Tempo setup', type: 'number' }
]

interface ServicesSubHeaderProps {
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  isLoading?: boolean
  appliedFilters: Filter[]
  onApplyFilter: (f: Filter) => void
}

const ServicesSubHeader: React.FC<ServicesSubHeaderProps> = ({ setRefresh, isLoading, appliedFilters, onApplyFilter }) => {
  const navigate = useNavigate()
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false)
  const filterButtonRef = useRef<HTMLDivElement | null>(null)
  
  const handleCreateClick = () => {
    navigate('create')
  }
  
  return (
    <SubHeaderContainer>
      <LeftSide>
        <SectionName>Serviços</SectionName>
      </LeftSide>
      <RightSide style={{ position: 'relative', alignItems: 'center' }}>
        <RefreshIconContainer onClick={() => setRefresh(prev => !prev)} title="Atualizar">
          <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
        </RefreshIconContainer>
        <FilterWrapper>
          <OptionsButton ref={filterButtonRef} onClick={() => setIsFilterMenuOpen(true)}>
            <FilterIcon size={18} />
          </OptionsButton>
          {isFilterMenuOpen && (
            <FilterMenu
              headers={serviceHeaders}
              onApplyFilter={(f) => {
                onApplyFilter(f)
                setIsFilterMenuOpen(false)
              }}
              onClose={() => setIsFilterMenuOpen(false)}
              anchorRef={filterButtonRef}
              filters={appliedFilters}
            />
          )}
        </FilterWrapper>
        <ButtonCreate onClick={handleCreateClick}>
          + Novo serviço
        </ButtonCreate>
      </RightSide>
    </SubHeaderContainer>
  )
}

const ServicesContent = () => {  
  const { search } = useOutletContext<TypeMainOutlet>()
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  
  const servicesFiltersState = usePersistedFilters('services')

  const outletContext = { 
    refresh, 
    setIsLoading, 
    isLoading,
    appliedFilters: servicesFiltersState.appliedFilters
  }
  
  return (
    <>
      <ServicesSubHeader 
        setRefresh={setRefresh} 
        isLoading={isLoading} 
        appliedFilters={servicesFiltersState.appliedFilters}
        onApplyFilter={servicesFiltersState.handleApplyFilter}
      />
      {servicesFiltersState.appliedFilters.length > 0 && (
        <AppliedFiltersDisplay
          filters={servicesFiltersState.appliedFilters}
          onRemoveFilter={servicesFiltersState.handleRemoveFilter}
          onClearAll={servicesFiltersState.handleClearAll}
        />
      )}
      <Content>
        <Outlet context={{ search, outletContext }}/>
      </Content>
    </>
  )
}

export default ServicesContent